import React from "react";
import { Box, Heading, Image, SimpleGrid, Text, VStack } from "@chakra-ui/react";

/**
 * The four "How it works" steps — Sam Manger's wording, SurgReady website feedback 27 Jul 2026.
 * One copy, shown on the homepage AND the /how-it-works page, so the two never disagree.
 *
 * Wording rules from that document (AHPRA advertising): nothing "personalised" unless it is the
 * person personalising their OWN plan, and no promised outcome ("what you'll achieve").
 */
export const HOW_IT_WORKS_STEPS = [
    {
        title: "Sign up and assessment",
        description: "Create your account and complete our health assessment, ready to provide to your healthcare team.",
        image: "/surgready/optomise_images/health-navigation.jpg",
        alt: "A person filling in a health assessment",
    },
    {
        title: "Start your modules",
        description: "Work through the evidence-informed education modules at your own pace, covering important areas of lifestyle, social and medical optimisation.",
        image: "/surgready/optomise_images/nitrition.jpg",
        alt: "Healthy food being prepared",
    },
    {
        title: "Provider integration",
        description: "Share progress with your healthcare team for coordinated care.",
        image: "/surgready/hero-doctor-patient.png",
        alt: "A doctor talking with a patient",
    },
    {
        title: "SurgReady",
        description: "Arrive at your surgery prepared and optimised for success.",
        image: "/surgready/running-couple.png",
        alt: "A couple out running together",
    },
];

/** The four steps as picture cards. Dark surfaces, to sit on the homepage's black sections. */
export function HowItWorksStepCards() {
    return (
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={6} w="full">
            {HOW_IT_WORKS_STEPS.map((step, i) => (
                <Box
                    key={step.title}
                    bg="rgba(255,255,255,0.03)"
                    border="1px solid"
                    borderColor="whiteAlpha.100"
                    borderRadius="2xl"
                    overflow="hidden"
                >
                    <Image src={step.image} alt={step.alt} w="full" h="180px" objectFit="cover" loading="lazy" />
                    <VStack align="flex-start" spacing={2} p={6}>
                        <Text fontSize="sm" textTransform="uppercase" letterSpacing="0.15em" color="#7AB0FF" fontWeight="600">
                            Step {i + 1}
                        </Text>
                        <Heading as="h3" fontSize="xl" fontWeight="500" color="white">
                            {step.title}
                        </Heading>
                        <Text fontSize="md" color="whiteAlpha.800" lineHeight="1.6">
                            {step.description}
                        </Text>
                    </VStack>
                </Box>
            ))}
        </SimpleGrid>
    );
}
